import { render } from "./TopIndexing.vue?vue&type=template&id=91630e4a&scoped=true"
import script from "./TopIndexing.vue?vue&type=script&lang=js"
export * from "./TopIndexing.vue?vue&type=script&lang=js"

import "./TopIndexing.vue?vue&type=style&index=0&id=91630e4a&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91630e4a"]])

export default __exports__